import { useAutoneTranslation } from '@autone/translations';

import { Button } from '../../../../atoms';
import { ArrowRightShortIcon, ClockIcon } from '../../../../icons';
import { cn } from '../../../../utils';
import { SIDEBAR_MENU_BUTTON_STYLE_OVERRIDES } from '../../constants/sidebarMenuButtonStyleOverrides';
import { DATA_FRESHNESS_BUTTON_ID } from '../const';
import { DataFreshnessWidgetTooltip } from '../DataFreshnessWidgetTooltip';

export const DataFreshnessLoadingButton = () => {
  const { common } = useAutoneTranslation();
  return (
    <DataFreshnessWidgetTooltip>
      <Button
        id={DATA_FRESHNESS_BUTTON_ID}
        aria-label={common('data-age.global-widget.label')}
        variant="ghost"
        disabled
        className={cn(
          SIDEBAR_MENU_BUTTON_STYLE_OVERRIDES,
          'disabled:pointer-events-auto disabled:cursor-progress hover:bg-background',
        )}
      >
        <ClockIcon />
        <div className="flex items-center gap-3 w-full group-data-[state=collapsed]:hidden">
          <div className="font-normal">
            {common('data-age.global-widget.label')}
          </div>
          <ArrowRightShortIcon className="ml-auto" />
        </div>
      </Button>
    </DataFreshnessWidgetTooltip>
  );
};
